
module.exports = function getResource(label, vars = []) {
    let resources = {
        close: 'Fermer',
        view: 'Afficher'
    };
    return resources[label];
};
